import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { CountryCode, LogisticContractStatus } from '@/Enums';
import { countryZoneUtils } from './utils';
import { ApplicationAccessCountryZoneCountryModel } from '@/Models/ApplicationAccessCountryZones/ApplicationAccessCountryZoneCountryModel';
import { ApplicationAccessCountryZoneModel } from '@/Models/ApplicationAccessCountryZones/ApplicationAccessCountryZoneModel';
import { asyncActions } from './asyncActions';

export type ApplicationAccessState = {
  countryZones: ApplicationAccessCountryZoneCountryModel[];
  selectedUuid: string;
  selectedCountryCode: CountryCode | null;
  connectionStatus: LogisticContractStatus;
};

const initialState: ApplicationAccessState = {
  countryZones: [],
  selectedUuid: '',
  selectedCountryCode: null,
  connectionStatus: LogisticContractStatus.Unknown,
};

const applicationAccessSlice = createSlice({
  name: 'generatorCountryZonesState',
  initialState,
  reducers: {
    setSelectedUuid(state, action: PayloadAction<string>) {
      state.selectedUuid = action.payload;
    },
    setSelectedCountryCode: (state, action: PayloadAction<CountryCode>) => {
      state.selectedCountryCode = action.payload;
    },
    addCountryZone(state, action: PayloadAction<ApplicationAccessCountryZoneModel>) {
      countryZoneUtils.addZone(state.countryZones, action.payload);
    },
    resetConnectionStatus(state) {
      state.connectionStatus = LogisticContractStatus.Unknown;
    },
    deleteCountryZone(state, action: PayloadAction<ApplicationAccessCountryZoneModel>) {
      countryZoneUtils.deleteZone(state.countryZones, action.payload.id);
    },
    clearData(state) {
      state.countryZones = [];
      state.selectedUuid = '';
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(asyncActions.getCountryZonesRequest.fulfilled, (state, action) => {
        state.countryZones = action.payload.countryZones;
      })
      .addCase(asyncActions.createCountryZoneRequest.fulfilled, (state, action) => {
        countryZoneUtils.updateZone(state.countryZones, action.payload.countryZone, state.selectedUuid);
        state.selectedUuid = '';
      })
      .addCase(asyncActions.updateCountryZoneRequest.fulfilled, (state, action) => {
        countryZoneUtils.updateZone(state.countryZones, action.payload.countryZone);
        state.selectedUuid = '';
      })
      .addCase(asyncActions.deleteCountryZoneRequest.fulfilled, (state, action) => {
        countryZoneUtils.deleteZone(state.countryZones, action.payload);
        state.selectedUuid = '';
      })
      .addCase(asyncActions.checkConnectionRequest.fulfilled, (state, action) => {
        state.connectionStatus = action.payload?.status;
      });
  },
});

const { actions, reducer } = applicationAccessSlice;

export const applicationAccessActions = actions;
export const applicationAccessReducer = reducer;
export const applicationAccessAsyncActions = asyncActions;
